import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PrescriptionHistory from "../Prescription/PrescriptionHistory";
import Allergies from "../Prescription/Allergies";
import Warnings from "../Prescription/Warnings";
import { Table } from "semantic-ui-react";
import ListGroupCollapse from "../../common/ListGroupCollapse";
import { Button as Button1, Message, Icon, Header, Modal as Modal1, Tab, Label, Menu, Input as Input1 } from 'semantic-ui-react'
import Webcam from "react-webcam";
import Hotkeys from "react-hot-keys";
import axios from "axios";
import { InputFile } from 'semantic-ui-react-input-file'

import {
    Container,
    Card,
    CardHeader,
    TabContent,
    TabPane,
    Badge,
    Row,
    Col,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert, CardFooter, Input
} from "reactstrap";
import RXInfo from "./RXInfo";
import classnames from "classnames";
import RXWarnings from "./RXWarnings";
import ImageCaptures from "./ImageCaptures";
import Markers from "./Markers";
import { getPrescriptions, postPrescriptions, getDurInfo, getPrescriptionHistory, getPrescriptionByNumber, presc_modal_view } from "../../../actions/mqttAction";
import Spinner from "../../common/Spinner";
import _ from "lodash";
import DraftComponent from "../DraftComponent";

import isEmpty from "lodash";
import TooltipItem from "../../common/TooltipItem";

class PrescriptionComponent extends Component {
    setRef = webcam => {
        this.webcam = webcam;
    };
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();

        // this.toggleNext = this
        //     .toggleNext
        //     .bind(this);
        // this.togglePrevious = this
        //     .togglePrevious
        //     .bind(this);
        this.save = this
            .save
            .bind(this);
        this.onCapture = this
            .onCapture
            .bind(this);
        this.checked = this
            .checked
            .bind(this);
        this.onSubmit = this
            .onSubmit
            .bind(this);
        this.onChange = this
            .onChange
            .bind(this);
        this.onSave = this
            .onSave
            .bind(this);
        this.toggleModal = this
            .toggleModal
            .bind(this);
        this.toggleAllergiesModel = this
            .toggleAllergiesModel
            .bind(this);
        this.topressKey = this.topressKey.bind(this);
        this.handleStartClick = this
            .handleStartClick
            .bind(this);
        // this.toggle = this
        //     .toggle
        //     .bind(this);
        this.showImage = this
            .showImage
            .bind(this);

        this.state = {
            setHotKeys: false,
            uploadType: 'pdf',
            modalCameraActive: false,
            modalCapturedImage: null,
            toggleImage: false,
            toShow_image: {},
            collapse: false,
            headers: {},
            activeTab: "1",
            modal: false,
            draft: [],
            prescriptionHistory: [],
            counsellingNotes: "",
            notes: "",
            ndcToValidate: "",
            patientIndicationstoValidate: "",
            requireConsult: false,
            ppmRequired: false,
            onHold: false,
            partial: false,
            prescriptionData: {},
            patientWaiting: false,
            isValid: false,
            canSubmit: true,
            showDur: false,
            showAllergiesModel: false,
            activeImage: "",
            loads: true,
            cameraActive: false,
            rxAttached: false,
            fileToUpload: "",
            uploadSource: '',
            imageLabels: [
                {
                    imageLabel: "Prescription Image",
                    imageType: "prescriptionImage",
                    imageSrc: ""
                }, {
                    imageLabel: "Label Image",
                    imageType: "labelImage",
                    imageSrc: ""
                }, {
                    imageLabel: "Pill Image",
                    imageType: "pillImage",
                    imageSrc: ""
                }, {
                    imageLabel: "Rx Bottle Image",
                    imageType: "rxbottle",
                    imageSrc: ""
                }
            ],
            imageLabel: "Additional",
            imageCounter: 1,
            isFromModal: false
        };
        this.handler = this
            .handler
            .bind(this)
        this.showDUR = this
            .showDUR
            .bind(this)

        this.togglePatAllergiesModel = this.togglePatAllergiesModel.bind(this)
        this.toggleDurModal = this.toggleDurModal.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
    }

    componentDidMount() {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let branchName;
        branchName = localStorage.branch
            ? localStorage.branch
            : "Chama";
        this
            .props
            .getPrescriptionByNumber(orgId, `branchName=${this.props.prescription[0].branchName}`, this.props.prescriptionNumber, this.props.prescription[0].prescriptionStatus);
        this
            .props

            .getPrescriptionHistory(orgId, `${this.props.prescription[0].branchName}`, this.props.patientId);

        this.setState({
            ...this.state,
            loads: this.props.loads
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let prescriptionHistory1 = nextProps.mqtt.prescriptionHistory;
        this.setState({ ...this.state, prescriptionHistory: prescriptionHistory1 });
        if (Object.keys(nextProps.mqtt.prescriptionByNumber).length > 0) {

            // console.log("===========prescription=============="+JSON.stringify(this.props.mqtt.prescriptionByNumber))
            // let p_num = nextProps.mqtt.prescriptionByNumber;
            // if(p_num.patientInfo){
            //     this.setState({
            //         ...this.state,
            //         patientWaiting:p_num.patientInfo.patientAdditionalInfo.patientWaiting
            //     })
            // }


            if (nextProps.mqtt.prescriptionByNumber.durInfo && nextProps.mqtt.prescriptionByNumber.durInfo.interactionCount && !this.state.durInfo) {
                this
                    .props
                    .getDurInfo(nextProps.mqtt.prescriptionByNumber);
            }
            if (Object.keys(nextProps.mqtt.durInfo).length > 0) {
                this.setState({ durInfo: nextProps.mqtt.durInfo });
            }
            let ndcImage;
            const imageLabels = this.state.imageLabels;
            nextProps.mqtt.prescriptionByNumber
                .prescriptionImageUrls
                .forEach(images => {
                    if (images.imageType === "ndcPillImage") {
                        console.log("=========NDC IMAGE+============" + images.imageUrl);
                        ndcImage = "" + images.imageUrl;
                        // /console.log("=======NDC Image==========="+ndcImage)
                        this.setState({ ...this.state, ndcImage: ndcImage });
                        //imageLabels.unshift(images)
                    }

                    if (images.imageType === "prescriptionImage") {
                        imageLabels[0].imageSrc = images.imageUrl;
                    }

                    if (images.imageType === "labelImage") {
                        imageLabels[1].imageSrc = images.imageUrl;
                    }
                    if (images.imageType === "pillImage") {
                        imageLabels[2].imageSrc = images.imageUrl;
                    }
                    if (images.imageType === "rxbottle")
                        imageLabels[3].imageSrc = images.imageUrl;
                }
                );

            // let p_waiting;
            // nextProps.mqtt.prescriptionByNumber.patientInfo.patientAdditionalInfo.patientWaiting?
            // p_waiting=this.props.mqtt.prescriptionByNumber.patientInfo.patientAdditionalInfo.patientWaiting:p_waiting=false
            this.setState({
                ...this.state,
                imageLabels: imageLabels,
                prescriptionData: this.props.mqtt.prescriptionByNumber,
                // patientWaiting:p_waiting,
                loads: false
            });

            let headers = {};

            const prescriptionByNumber = nextProps.mqtt.prescriptionByNumber;
            const prescriptionHistory = nextProps.mqtt.prescriptionHistory;

            prescriptionByNumber
                .prescriptionImageUrls
                .forEach(images => {
                    if (images.imageType === "ndcPillImage")
                        //ndcImage = `https://www.telerx.io${images.imageUrl}`;
                        this.setState({ ndcImage: ndcImage });
                });

            headers.PrescriptionDetails = {
                header: "Prescription Details",
                content: (<RXInfo
                    draft={prescriptionByNumber}
                    style={{
                        backgroundColor: "#fff"
                    }} />)
            };
            headers.Markers = {
                header: "Markers",
                content: (<Markers prescription={prescriptionByNumber.patientInfo.patientAdditionalInfo} prescriptionStatus={prescriptionByNumber.prescriptionStatus} save={this.save} checked={this.checked} />)
            };

            headers.MedicationHistory = {
                header: "Medication History",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.medicationHistory)
                            ? (<PrescriptionHistory
                                prescriptionHistory={prescriptionHistory}
                                prescriberInfo={prescriptionByNumber.prescriberInfo} />)
                            : (
                                <span>No medication history available</span>
                            )}
                    </div>
                )
            };
            headers.Allergies = {
                header: "Allergies",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.allergies)
                            ? (<Allergies prescriptionHistory={prescriptionHistory} />)
                            : (
                                <span>No allergies available</span>
                            )}
                    </div>
                )
            };
            headers.Warnings = {
                header: "Warnings",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.warnings)
                            ? (<Warnings prescriptionHistory={prescriptionHistory} />)
                            : (
                                <span>No warnings available</span>
                            )}
                    </div>
                )
            };
            headers.AuditLogs = {
                header: "Audit Logs",
                content: (
                    <ul>
                        {prescriptionByNumber
                            .auditLogs
                            .map(auditLog => (
                                <li key={auditLog}>{auditLog}</li>
                            ))}
                    </ul>
                )
            };

            this.setState({
                headers: headers,
                patientWaiting: prescriptionByNumber.patientInfo.patientAdditionalInfo.patientWaiting,
                notes: prescriptionByNumber.patientInfo.patientAdditionalInfo.notes,
                requireConsult: prescriptionByNumber.patientInfo.patientAdditionalInfo.requireConsult,
                ppmRquired: prescriptionByNumber.patientInfo.patientAdditionalInfo.ppmRquired,

            });
            if (Object.keys(nextProps.mqtt.durInfo).length > 0) {
                this.setState({ durInfo: nextProps.mqtt.durInfo });
            }
            if (nextProps.mqtt.prescriptionByNumber.durInfo &&
                nextProps.mqtt.prescriptionByNumber.durInfo.interactionCount && !this.state.durInfo) {
                this.props.getDurInfo(nextProps.mqtt.prescriptionByNumber);
            }
            // this.setState({
            //     ...this.state,

            // })
        }
    }

    // toggleNext() {
    //     let activeTab = parseInt(this.state.activeTab, 10) + 1;
    //     this.setState({
    //         activeTab: activeTab.toString()
    //     });
    // }

    handler(approvedLength) {
        this.setState({
            ...this.state,
            app_length: approvedLength

        });

    }

    // togglePrevious() {
    //     let activeTab = parseInt(this.state.activeTab, 10) - 1;
    //     this.setState({
    //         activeTab: activeTab.toString()
    //     });
    // }

    save(e) {
        if (this.props.auth.user.roles[0].toUpperCase() === 'TECHNICIAN') {
            console.log("=====Target==========" + e.target.name)
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    checked(e) {
        //console.log("==========checks==========="+e.target.name)
        if (e.target.name === "requireConsult") {
            this.setState({
                requireConsult: !this.state.requireConsult
            });
        }

        if (e.target.name === "ppmRquired") {
            this.setState({
                ppmRquired: !this.state.ppmRquired
            });
        }
        if (e.target.name === "onHold")
            this.setState({
                onHold: !this.state.onHold
            });

        if (e.target.name === "partial") {
            console.log("==============Patient Waiting==============" + this.state.patientWaiting)

            this.setState({
                partial: !this.state.partial
            });

        }

        if (e.target.name === "patientWaiting") {
            //console.log("==============Patient Waiting=============="+this.state.patientWaiting)
            this.setState({
                patientWaiting: !this.state.patientWaiting
            });

        }

    }

    onCapture() {

        let currentIndex = this.state.currentIndex

        if (this.state.currentIndex < this.state.imageLabels.length - 1) {
            let nextLabel = this.state.imageLabels[this.state.currentIndex + 1];
            if (nextLabel.imageSrc !== "") {
                this.setState({
                    ...this.state,
                    activeImage: "",
                    cameraActive: false,
                    setHotKeys: false,
                    currentIndex: currentIndex + 1
                });
            }
            else {
                this.setState({
                    ...this.state,
                    activeImage: nextLabel.imageLabel,
                    cameraActive: true,
                    setHotKeys: true,
                    currentIndex: currentIndex + 1
                });

            }
        }
        else {
            this.setState({
                ...this.state,
                activeImage: "",
                cameraActive: false,
                setHotKeys: false,
                currentIndex: currentIndex + 1
            });
        }
    }


    onSave() {
        //let prescriptionData = this.state.prescriptionData;
        let prescriptionData = this.props.mqtt.prescriptionByNumber
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        const markers = {
            counsellingNotes: this.state.counsellingNotes,
            notes: this.state.notes,
            requireConsult: this.state.requireConsult,
            ppmRequired: this.state.ppmRquired,
            onHold: this.state.onHold,
            partial: this.state.partial,
            patientWaiting: this.state.patientWaiting
        };

        let imagel = []

        this.state.imageLabels.map(prescp => {
            let img;
            if (prescp.imageType === "ndcPillImage") {
                // img = {
                //     imageType:"ndcPillImage",
                //     imageUrl:this.state.ndcImage
                // }
            }
            else {
                if (prescp.imageUrl) {
                    img = {
                        imageType: prescp.imageType,
                        imageUrl: prescp.imageUrl
                    }
                }
                else {
                    img = {
                        imageType: prescp.imageType,
                        imageUrl: prescp.imageSrc
                    }
                }
            }

            imagel.push(img)
        })

        let ndc = {
            imageType: "ndcPillImage",
            imageUrl: this.state.ndcImage
        }
        imagel.unshift(ndc);
        prescriptionData.prescriptionImageUrls = imagel
        prescriptionData.patientInfo.patientAdditionalInfo = markers;
        //console.log("=================Prescription waiting1==============="+this.state.patientWaiting)
        prescriptionData.patientInfo.patientAdditionalInfo.patientWaiting = this.state.patientWaiting;
        console.log("===============Partial===================" + this.state.partial)
        prescriptionData.patientInfo.patientAdditionalInfo.partial = this.state.partial;
        prescriptionData.patientInfo.patientAdditionalInfo.requireConsult = this.state.requireConsult
        prescriptionData.patientInfo.patientAdditionalInfo.ppmRequired = this.state.ppmRequired;
        prescriptionData.patientInfo.patientAdditionalInfo.notes = this.state.notes;
        //console.log("=================Prescription waiting1==============="+prescriptionData.patientInfo.patientAdditionalInfo.patientWaiting)
        prescriptionData.technicianId = this.props.auth.user.sub;
        prescriptionData.isEditing = false;
        //prescriptionData.rxInfo.rxStatus = "Pending"
        //console.log("=================Prescription Data==============="+JSON.stringify(prescriptionData))
        this
            .props
            .postPrescriptions(orgId, prescriptionData, this.props.history)
        this
            .props
            .presc_modal_view(false, {}, '', '');
    }

    onChange = e => {
        if (e.target.value.match("^[a-zA-Z 0-9]*$") != null) {
            this.setState({ [e.target.name]: e.target.value })
        }
    }
    onSubmit = async () => {
        //let prescriptionData = this.state.prescriptionData;
        const { fileToUpload, ndcToValidate, patientIndicationstoValidate } = this.state;
        const toShow = this.state.showAllergiesModel;
        const isValidNDC = this.props.mqtt.prescriptionByNumber.rxInfo.ndcNumber == ndcToValidate.trim().replace("-", "");
        if (fileToUpload) {
            await this.handleUpload();
        }

        if (toShow && (!ndcToValidate || !patientIndicationstoValidate)) {
            alert('Required Information is Missing');
            return;
        }

        if (toShow && ndcToValidate && patientIndicationstoValidate && !isValidNDC) {
            alert('Invalid NDC, Please check');
            return;
        }
        let prescriptionData = this.props.mqtt.prescriptionByNumber
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        const markers = {
            counsellingNotes: this.state.counsellingNotes,
            notes: this.state.notes + ' , ' + this.state.comments,
            requireConsult: this.state.requireConsult,
            ppmRequired: this.state.ppmRquired,
            onHold: this.state.onHold,
            partial: this.state.partial,
            patientWaiting: this.state.patientWaiting
        };
        let imagel = []

        this.state.imageLabels.map(prescp => {
            let img;
            if (prescp.imageType === "ndcPillImage") {
                // img = {
                //     imageType:"ndcPillImage",
                //     imageUrl:this.state.ndcImage
                // }
            }
            else {
                if (prescp.imageUrl) {
                    img = {
                        imageType: prescp.imageType,
                        imageUrl: prescp.imageUrl
                    }
                }
                else {
                    if ("prescriptionImage" === prescp.imageType && this.state.fileToUpload) {
                        let imgRx = prescp.imageSrc.replace('jpg', 'pdf')
                        img = {
                            imageType: prescp.imageType,
                            imageUrl: imgRx
                        }
                    } else {
                        img = {
                            imageType: prescp.imageType,
                            imageUrl: prescp.imageSrc
                        }
                    }
                }
            }

            imagel.push(img)
        })

        let ndc = {
            imageType: "ndcPillImage",
            imageUrl: this.state.ndcImage
        }
        imagel.unshift(ndc);
        prescriptionData.prescriptionImageUrls = imagel
        prescriptionData.patientInfo.patientAdditionalInfo = markers;
        if (prescriptionData.patientInfo.patientAdditionalInfo.notes !== undefined) {
            prescriptionData.patientInfo.patientAdditionalInfo.notes = this.state.p_allergies + ' , ' + this.state.patientIndicationstoValidate + ' , ' + prescriptionData.patientInfo.patientAdditionalInfo?.notes.split(' , ')?.slice(1)?.join(' , ').trim()
        } else {
            prescriptionData.patientInfo.patientAdditionalInfo.notes = this.state.p_allergies + ' , PatientIndicators::' + this.state.patientIndicationstoValidate + ' , Comments::' + this.state.comments;
        }

        //console.log("=================Prescription waiting1==============="+this.state.patientWaiting)
        prescriptionData.patientInfo.patientAdditionalInfo.patientWaiting = this.state.patientWaiting;
        prescriptionData.patientInfo.patientAdditionalInfo.partial = this.state.partial;

        //console.log("=================Prescription waiting1==============="+prescriptionData.patientInfo.patientAdditionalInfo.patientWaiting)
        prescriptionData.technicianId = this.props.auth.user.sub;
        prescriptionData.isEditing = false;
        prescriptionData.rxInfo.rxStatus = "Pending"
        //console.log("=================Prescription Data==============="+JSON.stringify(prescriptionData))
        this
            .props
            .postPrescriptions(orgId, prescriptionData, this.props.history)
        this
            .props
            .presc_modal_view(false, {}, '', '');
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }
    showDUR(toShow) {
        this.setState({
            ...this.state,
            showDur: toShow
        })
    }

    toggleAllergiesModel() {
        this.setState({
            showAllergiesModel: false,
            canSubmit: true,
            modalCameraActive: false,
            modalCapturedImage: null,
            p_allergies: '',
            uploadType: null,
            canSubmit: true,
            setHotKeys: false,
        });
    }

    togglePatAllergiesModel() {

        if (this.modalCameraStream) {
            this.modalCameraStream.getTracks().forEach((track) => track.stop());
        }
        this.setState(prev => ({
            showAllergiesModel: !prev.showAllergiesModel
        }));
    }

    toggleDurModal() {
        let toShow = this.state.showDur;
        this.setState({
            ...this.state,
            showDur: !toShow
        })
    }

    getDurModal() {
        let prescription = this.props.mqtt.prescriptionByNumber;
        let durModal = <div></div>
        if (Object.keys(prescription).length > 0) {
            if (prescription && prescription.durInfo) {
                let mbody = ""
                var ReactDOMServer = require('react-dom/server');
                var HtmlToReactParser = require('html-to-react').Parser;
                var htmlToReactParser = new HtmlToReactParser();
                var reactElement = htmlToReactParser.parse("<div></div>");
                if (this.state.durInfo) {
                    reactElement = htmlToReactParser.parse(this.state.durInfo.professionalMonograph);
                }
                let modalBody;
                let severityLevel = prescription.durInfo.seviorityLevel

                if (severityLevel === "Major") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "red", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>
                        {reactElement}
                    </div>
                }
                else if (severityLevel === "medium") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "orange", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>
                        {reactElement}
                    </div>
                }
                else if (severityLevel === "low") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "#007bff", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>
                        {reactElement}
                    </div>
                }
                else if (severityLevel === "Unknown") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "grey", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>
                        {reactElement}
                    </div>
                }
                else {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong><h4 > Interraction Count : <span style={{ color: "teal", fontSize: "1.5rem" }}>{prescription.durInfo.interactionCount}</span></h4></strong>
                            </Col>
                            <Col md="1" lg="1">
                            </Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong><h4 > Severity : <span className=" text-capitalize" style={{ color: "grey", fontSize: "1.5rem" }}>{prescription.durInfo.seviorityLevel}</span></h4></strong>
                            </Col>
                        </Row>
                        {reactElement}
                    </div>
                }

                durModal = <div>
                    <Modal isOpen={this.state.showDur} backdrop={true} className="dur-modal bg-light" centered
                        dialogClassName="custom-modal" bsClass="my-modal">
                        <ModalHeader toggle={this.toggleDurModal} ><h4><strong>DRUG UTILIZATION REVIEW</strong></h4> </ModalHeader>
                        <ModalBody>
                            {modalBody}
                        </ModalBody>
                    </Modal>
                </div>
            }
        }
        return durModal;
    }

    getDUR() {
        let dur = <Message icon color="red" className="dur-message" onClick={() => { this.showDUR(true); }}>
            <i class="fas fa-exclamation" color="red mr2"></i>
            <Message.Content className="text-center  ">
                <Message.Header>DUR Found
                    {/* <span className="dur-view"><i className="fas fa-eye"/></span> */}
                </Message.Header>

            </Message.Content>
        </Message>
        return dur;
    }

    // toggle(headers) {
    //     this.setState({
    //         collapse: this.state.collapse === headers
    //             ? null
    //             : headers
    //     });
    // }

    getPrescHeaders() {
        const { prescriptionByNumber, loading } = this.props.mqtt;
        let prescription = this.props.mqtt.prescriptionByNumber;

        let durItem = <div></div>;

        if (prescription.durInfo && prescription.durInfo.interactionCount) {
            let seviorityLevel = prescription.durInfo.seviorityLevel;

            if (seviorityLevel === "Major") {
                durItem = <Menu compact className="ml-4" onClick={() => {
                    this.showDUR(true
                    );
                }}>
                    <Menu.Item as='a' color="red">
                        {/* <Icon name='mail' /> */}
                        <span style={{ color: "red" }}> DUR Found</span>
                        <Label color='red' floating>
                            {prescription.durInfo.interactionCount}
                        </Label>
                    </Menu.Item>
                </Menu>
            }

            else if (seviorityLevel === "low") {
                durItem = <Menu compact className="ml-4" onClick={() => {
                    this.showDUR(true
                    );
                }}>
                    <Menu.Item as='a' color="#007bff">
                        {/* <Icon name='mail' /> */}
                        <span style={{ color: "#007bff" }}> DUR Found</span>
                        <Label color='#007bff' style={{ color: "white", backgroundColor: "#007bff" }} floating>
                            {prescription.durInfo.interactionCount}
                        </Label>
                    </Menu.Item>
                </Menu>
            }

            else if (seviorityLevel === "medium") {
                durItem = <Menu compact className="ml-4" onClick={() => {
                    this.showDUR(true
                    );
                }}>
                    <Menu.Item as='a' color="#007bff">
                        {/* <Icon name='mail' /> */}
                        <span style={{ color: "orange" }}> DUR Found</span>
                        <Label color='#007bff' style={{ color: "black", backgroundColor: "orange" }} floating>
                            {prescription.durInfo.interactionCount}
                        </Label>
                    </Menu.Item>
                </Menu>
            }

            else if (seviorityLevel === "Unknown") {
                durItem = <Menu compact className="ml-4" onClick={() => {
                    this.showDUR(true
                    );
                }}>
                    <Menu.Item as='a' color="grey">
                        {/* <Icon name='mail' /> */}
                        <span style={{ color: "black" }}> DUR Found</span>
                        <Label color='#007bff' style={{ color: "black", backgroundColor: "grey" }} floating>
                            {prescription.durInfo.interactionCount}
                        </Label>
                    </Menu.Item>
                </Menu>
            }

            else {
                durItem = <Menu compact className="ml-4" onClick={() => {
                    this.showDUR(true
                    );
                }}>
                    <Menu.Item as='a' color="grey">
                        {/* <Icon name='mail' /> */}
                        <span style={{ color: "black" }}> DUR Found</span>
                        <Label color='#007bff' style={{ color: "black", backgroundColor: "grey" }} floating>
                            {prescription.durInfo.interactionCount}
                        </Label>
                    </Menu.Item>
                </Menu>
            }
        }
        const headers = this.state.headers
        let collapse = this.state.collapse
        let headers_pres;
        let panes = []
        let ndcImg = this.state.ndcImage

        if (Object.keys(prescriptionByNumber).length > 0) {

            {
                Object.keys(headers).map((key, index) => (
                    panes.push({ menuItem: key, pane: headers[key] },)))
            }
            headers_pres = <div>
                <Row className="py-2">
                    <Col md="5">
                        <span className="font-style mb-1 text-capitalize">
                            NDC: {prescriptionByNumber.rxInfo.ndcNumber}
                        </span>
                        {/* image:{this.state.ndcImage} */}
                        <img src={this.state.ndcImage} alt="" />
                    </Col>
                    <Col md="7" className="pt-4">
                        <Table>
                            <tbody className="font-style">
                                <tr>
                                    <td>
                                        <div className="d-inline-block">
                                            <i className="d-inline fas fa-edit text-info mr-2" />
                                            <h3 className="d-inline">
                                                {prescriptionByNumber.rxInfo.prescriptionNumber}
                                            </h3>
                                            <Badge className="d-inline text-center" color="warning ml-2">
                                                {prescriptionByNumber.rxInfo.rxStatus}
                                            </Badge>
                                            {durItem}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="text-info" /> {prescriptionByNumber.rxInfo.rxName}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="text-info" /> {prescriptionByNumber.rxInfo.strength}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row className="presc-headers">
                    <Tab panes={panes} renderActiveOnly={false} className="header-tabs" />
                </Row>
            </div>
        }
        else {
            headers_pres = <Spinner />
        }
        return headers_pres;
    }

    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const isPdf = file.type === 'application/pdf';
        const isImage = file.type.startsWith('image/');
        if (!isPdf && !isImage) {
            alert('Please upload a valid PDF or image file.');
            return;
        }
        this.setState({
            fileToUpload: file,
            fileType: isPdf ? 'pdf' : 'image',
            p_allergies: '',
            uploadSource: isPdf ? 'pdf' : 'image'
        });
    };

    render() {
        const { roles } = this.props.auth.user;
        const { patientId } = this.props;
        // const existingPatientAllergyInfo = this.props.mqtt.approvedPrescriptions.find(patient => patient?.patientInfo?.patientId === patientId);
        const existingPatientAllergyNotes = this.props.mqtt.prescriptionByNumber?.patientInfo?.patientAdditionalInfo?.notes?.split(' , ')[0]?.trim();
        let accessRole = roles[0];
        const {
            prescriptionHistory,
            counsellingNotes,
            notes,
            requireConsult,
            ppmRquired,
            onHold,
            partial, patientWaiting
        } = this.state;
        let { prescriptionByNumber, loading } = this.props.mqtt;
        console.log("=========this state partial========" + partial)
        //+++++++++prescriptionByNumber = this.state.prescriptionData;
        let draftPrescriptions,
            tabContent,
            rejectReason;
        const markers = {
            counsellingNotes: counsellingNotes,
            notes: notes,
            requireConsult: requireConsult,
            ppmRquired: ppmRquired,
            onHold: onHold,
            partial: partial,
            patientWaiting: patientWaiting
        };

        if (loading || this.state.loads) {
            draftPrescriptions = <Spinner />;
            tabContent = <Spinner />;
            rejectReason = <Spinner />;
        } else {
            if (Object.keys(prescriptionByNumber).length > 0) {
                let validPill = false,
                    validBottle = false,
                    validLabel = false,
                    isValid = false;

                if (!this.state.isValid) {
                    prescriptionByNumber
                        .prescriptionImageUrls
                        .map(image => {
                            if (image.imageType === "pillImage" && image.imageUrl !== "") {
                                validPill = true;
                            }

                            if (image.imageType === "rxbottle" && image.imageUrl !== "") {
                                validBottle = true;
                            }
                            if (image.imageType === "labelImage" && image.imageUrl !== "") {
                                validLabel = true;
                            }
                        });
                }

                if (validBottle && validPill && validLabel) {
                    this.setState({
                        ...this.state,

                        isValid: true
                    });
                }
                const { roles } = this.props.auth.user;
                let accessRole = roles[0];
                let submitButtons = <Button1.Group>
                    <InputFile
                        button={{ color: '#17a2b8', label: 'pdf', icon: 'fa-paperclip' }}
                        input={{
                            id: 'input-control-id',
                            onChange: e => { this.setState({ ...this.state, fileToUpload: e.target.files[0] }) },

                        }}

                    />
                    <Button1 className="btn-info" color="#17a2b8" onClick={this.onSave}>
                        <i className="mr-2 fa-lg fas fa-save " />
                        Save

                    </Button1>
                    <Button1.Or />
                    {!this.state.canSubmit
                        ? <Button1 loading color="#17a2b8">
                            Loading
                        </Button1>
                        : <Button1 className="presc-submit" color="#17a2b8"
                            onClick={this.togglePatAllergiesModel}
                            disabled={!_.has(this.state, "enableSubmit")}
                        >Submit
                            <i className="ml-2 fas fa-arrow-alt-circle-right fa-lg " /></Button1>}


                </Button1.Group>
                if (accessRole !== "TECHNICIAN") {
                    submitButtons = <div></div>
                }

                draftPrescriptions = (

                    <div>
                        <CardHeader
                            style={{
                                backgroundColor: "transparent",
                                borderBottom: "none"
                            }}> <div className="presc-header-row">
                                <Row>
                                    <Col md="3" lg="3">
                                        <div className="float-left text-info">
                                            <h2
                                                className="text-capitalize text-info"
                                                style={{
                                                    margin: "none!important"
                                                }}>
                                                {prescriptionByNumber.patientInfo.firstName}{" "} {prescriptionByNumber.patientInfo.lastName}
                                            </h2>
                                            <h5 className="d-inline text-muted text-info font-bigger">
                                                <i class="fas fa-birthday-cake fa-1x mr-1 teal"></i> {prescriptionByNumber.patientInfo.dateOfBirth}
                                            </h5>
                                            <h5 className="d-inline text-muted ml-4 text-info font-bigger">
                                                <i class="fas fa-address-card mr-1 fa-1x teal"></i>{prescriptionByNumber.patientInfo.address}
                                            </h5>
                                            <div
                                                className="custom-control custom-checkbox m-0">
                                                <Input className="custom-control-input" id="patientWaiting" style={{ fontSize: "1rem" }}
                                                    name="patientWaiting"
                                                    type="checkbox" defaultChecked={prescriptionByNumber.patientInfo.patientAdditionalInfo.patientWaiting}
                                                    onChange={this.checked} />
                                                <label className="custom-control-label text-uppercase"
                                                    htmlFor="patientWaiting" style={{ fontSize: "1rem", color: "red", fontWeight: "bolder" }}>
                                                    Patient Waiting</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md="6" lg="7">
                                        <Row className="container horizontal-scrollable presc-img-icons">
                                            {this.getImagesIcons()}
                                        </Row>
                                    </Col>
                                    <Col md="3" lg="2" className="presc-submits">
                                        <div className="float-right">
                                            <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                                                <ModalHeader toggle={this.toggleModal}>
                                                    <h3>Warning</h3>
                                                </ModalHeader>
                                                <ModalBody>
                                                    Your changes will be discarded! Proceed?
                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button tag={Link} to="/pharmacist-dashboard" color="secondary">
                                                        Confirm
                                                    </Button>
                                                    <Button color="secondary" onClick={this.toggleModal}>
                                                        Close
                                                    </Button>
                                                </ModalFooter>
                                            </Modal>
                                            {submitButtons}
                                        </div>

                                    </Col>
                                </Row>
                            </div>
                            {/* <Row>
                            
                            </Row> */}
                        </CardHeader>

                    </div>
                );

            } else {
                draftPrescriptions = <h4>No prescriptions found</h4>;
            }
        }

        let toShow = <Spinner />

        if (Object.keys(prescriptionByNumber).length > 0) {
            let rejectReason = <div></div>
            if (prescriptionByNumber.rxInfo.rxStatus === "Rejected") {
                rejectReason = (
                    <Container className="text-center">
                        <Alert color="danger">
                            <h3 className="reject-reason">
                                Reject Reason: {prescriptionByNumber.rxInfo.rejectReason}
                            </h3>
                        </Alert>
                    </Container>
                );
            }
            if (Object.keys(prescriptionByNumber).length > 0) {

                toShow = <div>
                    <Card className="card-width">
                        {draftPrescriptions}
                        <div className="card-block presc-card">
                            <div className="presc-left">
                                {rejectReason}
                                {this.getPrescHeaders()}
                            </div>
                            <div className="presc-right">
                                {this.getImageCaptures()}
                            </div>
                        </div>
                    </Card>
                    {this.getDurModal()}</div>
            }
        }
        if (loading || this.state.loads) {
            toShow = <Spinner />;
        }
        return (
            <div>
                <Modal isOpen={this.state.showAllergiesModel} toggle={this.togglePatAllergiesModel} size="lg" fullscreen="true" className="bg-light" style={{ maxWidth: "100%" }} centered>
                    <ModalHeader>
                        <h3>Provide Allergy Info and NDC Details</h3>
                    </ModalHeader>

                    <ModalBody>
                        <div>
                            <strong>Allergy File/Img Upload:</strong>

                            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', marginTop: '10px' }}>
                                <button
                                    type="button"
                                    className={`btn btn-info ${this.state.uploadType === 'pdf' ? 'active' : ''}`}
                                    onClick={() => {
                                        this.fileInputRef.current.click();
                                        this.setState({ uploadType: 'pdf', modalCapturedImage: null });
                                    }}
                                    disabled={this.state.uploadSource === 'image'}
                                >
                                    <i className="fas fa-paperclip"></i> Upload PDF
                                </button>

                                <button
                                    type="button"
                                    className={`btn btn-info ${this.state.uploadType === 'camera' ? 'active' : ''}`}
                                    onClick={() =>
                                        this.setState(
                                            { uploadType: 'camera', isFromModal: true, p_allergies: '' },
                                            this.activateCameraInModal
                                        )
                                    }
                                    disabled={this.state.uploadSource === 'pdf'}
                                >
                                    <i className="fas fa-camera"></i> Use Camera
                                </button>

                                {this.state.uploadSource && (
                                    <button
                                        className="btn btn-outline-secondary btn-sm"
                                        style={{ marginTop: '5px' }}
                                        onClick={this.resetUploadSelection}
                                    >
                                        <i className="fas fa-undo-alt mr-1"></i> Reset Upload
                                    </button>
                                )}

                                {existingPatientAllergyNotes && (
                                    <div
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginLeft: '16px',
                                            verticalAlign: 'middle',
                                            backgroundColor: '#f8fafc',
                                            padding: '6px 10px',
                                            borderRadius: '6px',
                                            border: '1px solid #e2e8f0',
                                            boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.04)',
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            id="existingAllergyInfo"
                                            name="existingAllergyInfo"
                                            onChange={(e) => this.copyAllergyInfo(e)}
                                            style={{
                                                width: '18px',
                                                height: '18px',
                                                accentColor: '#2563eb', // nice modern blue
                                                cursor: 'pointer',
                                                transform: 'scale(1.1)',
                                            }}
                                        />
                                        <label
                                            htmlFor="existingAllergyInfo"
                                            style={{
                                                fontSize: '14.5px',
                                                color: '#0f172a',
                                                fontWeight: 500,
                                                letterSpacing: '0.2px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Use existing patient allergy info
                                        </label>
                                    </div>
                                )}




                            </div>

                            <input
                                type="file"
                                accept="application/pdf"
                                style={{
                                    width: 0,
                                    height: 0,
                                    opacity: 0,
                                    position: 'absolute',
                                    left: '-9999px',
                                    overflow: 'hidden',
                                }}

                                ref={this.fileInputRef}
                                onChange={this.handleFileUpload}
                            />

                            {this.state.uploadType === 'pdf' ? (
                                this.state.p_allergies ? (
                                    <div style={{ marginTop: '10px', color: 'green' }}>
                                        ✅ File Uploaded successfully.
                                    </div>
                                ) : null
                            ) : (
                                <div id="modal-camera-section" style={{ marginTop: '10px' }}>
                                    {this.state.modalCameraActive && !this.state.modalCapturedImage ? (
                                        <>
                                            <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                <Hotkeys keyName="c" onKeyUp={this.topressKey}>
                                                    <Webcam
                                                        audio={false}
                                                        ref={(ref) => (this.webcam = ref)}
                                                        screenshotFormat="image/jpeg"
                                                        style={{
                                                            width: '70%',
                                                            height: '500px',
                                                            objectFit: 'cover',
                                                            border: '1px solid #000',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#000',
                                                        }}
                                                    />
                                                </Hotkeys>
                                            </div>
                                            <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                <button
                                                    onClick={this.handleStartClick}
                                                    className="btn btn-dark"
                                                    style={{ borderRadius: '50%', width: '60px', height: '60px' }}
                                                >
                                                    <i className="fas fa-camera"></i>
                                                </button>
                                            </div>
                                        </>
                                    ) : this.state.modalCapturedImage ? (
                                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                            <img
                                                src={this.state.modalCapturedImage}
                                                alt="Captured"
                                                style={{
                                                    maxWidth: '900px',
                                                    maxHeight: '500px',
                                                    width: '70%',
                                                    height: 'auto',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '8px',
                                                }}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            )}
                        </div>

                        <div>
                            NDC Info :{' '}
                            <Input
                                type="text"
                                name="ndcToValidate"
                                onChange={this.onChange}
                                placeholder="Enter NDC From RxBottle"
                            />
                        </div>
                        Patient Indication :{' '}
                        <Input
                            type="text"
                            name="patientIndicationstoValidate"
                            onChange={this.onChange}
                            placeholder="Enter Patient Indications"
                        />
                    </ModalBody>

                    <ModalFooter>
                        <Button1 color="teal" onClick={this.onSubmit}>
                            Confirm
                        </Button1>
                        <Button1 color="red" onClick={this.toggleAllergiesModel}>
                            Close
                        </Button1>
                    </ModalFooter>
                </Modal>


                <div class="presc-view">{toShow}</div>
            </div>
        );
    }
    getImageIcon(label, index) {
        let icon_image;
        if (label.imageSrc === "") {
            icon_image = <div
                style={{
                    cursor: "pointer"
                }}
                onClick={() => this.activateCamera(label.imageLabel)}
                key={index}>
                <div className="top">
                    <i className="fas fa-camera-retro fa-3x" />
                </div>
                <div className="centered">
                    <span>{label.imageLabel}</span>
                </div>
            </div>
        }
        else {
            let card_footer;
            if (label.imageSrc) {
                card_footer =
                    <div>
                        <div
                            style={{
                                cursor: "pointer"
                            }}>
                            <i
                                className="d-inline-block fas fa-pencil-alt float-left"
                                onClick={() => this.activateCamera(label.imageLabel)}
                                key={index} />
                        </div>

                        <div
                            style={{
                                cursor: "pointer"
                            }}>
                            <i
                                className="d-inline-block fas fa-eye float-right"
                                onClick={() => this.togglePreview(label.imageSrc)}
                                key={index} />
                        </div>
                    </div>

            }
            else {
                card_footer = ""
            }
            icon_image = <div> <img
                id={label.imageType}
                src={label.imageSrc}
                style={{
                    zIndex: "1"
                }}
                alt="" />
                <TooltipItem
                    tooltipText={label.imageLabel}
                    target={label.imageType}
                    placement="top" />
                <CardFooter>
                    {card_footer}
                </CardFooter>
            </div>
        }
        return icon_image;
    }

    handleUpload = () => {
        const file = this.state.fileToUpload;
        if (!file) {
            alert('No file to upload.');
            return Promise.resolve();
        }
        const fileName = this.getUploadImageName();
        const filePrefix = this.getUploadImagePrefix();
        const imageBase = "https://tpms-prescription-images.s3.amazonaws.com/";
        const attachmentUrl = `${imageBase}${filePrefix}/${fileName}`;

        return axios.post("https://280sdpcj87.execute-api.us-east-1.amazonaws.com/dev/requestUploadURL", {
            name: fileName,
            type: file.type,
            Prefix: `${filePrefix}/`,
        }).then(response => {
            return axios.put(response.data.uploadURL, file, {
                headers: {
                    "Content-Type": file.type,
                    "x-amz-acl": "public-read"

                },
                transformRequest: [(data, headers) => {
                    delete headers.common.Authorization;
                    return data;
                }]
            }).then(() => {
                console.log(" Uploaded to S3:", attachmentUrl);
                this.setState({
                    ...this.state,
                    p_allergies: attachmentUrl,
                    rxAttached: true,
                    attachmentUrl,
                    uploadSource: file.type === 'application/pdf' ? 'pdf' : 'image'
                });
            });
        }).catch(err => {
            console.error("Upload failed", err);
            alert("File upload failed. Please try again.");
        });
    };

    getImagesIcons() {
        let imageLabels = this.state.imageLabels;
        let imageLabelsArr;
        const { prescriptionByNumber, loading } = this.props.mqtt;
        let images_row
        if (Object.keys(prescriptionByNumber).length > 0) {

            imageLabelsArr = imageLabels.map((label, index) => (

                <div className="card-block img-div">

                    {label.imageSrc === "" ? (
                        <Card className="text-center">
                            <div className="ml-8"
                                style={{
                                    cursor: "pointer"
                                }}
                                onClick={() => this.activateCamera(label.imageLabel, index)}
                                key={index}>

                                <i className="fas fa-camera-retro fa-2x" />

                                {/* <div className="centered">
                                <span>{label.imageLabel}</span>
                            </div> */}


                            </div>
                            <CardFooter className="icon-footer">
                                <span>{label.imageLabel}</span>
                            </CardFooter>
                        </Card>
                    )
                        :
                        <Card>
                            <div>
                                <img className="image-icon"
                                    onClick={() => this.showImage(label)}
                                    id={label.imageType}
                                    src={label.imageSrc}
                                    style={{
                                        zIndex: "1", cursor: "pointer"

                                    }}
                                    alt="" />
                                <TooltipItem
                                    tooltipText={label.imageLabel}
                                    target={label.imageType}
                                    placement="top" /> {label.imageSrc
                                        ? (
                                            <CardFooter className="icon-footer">
                                                <div>
                                                    <div
                                                        className="text-center"
                                                        onClick={() => this.activateCamera(label.imageLabel, index)}
                                                        style={{
                                                            cursor: "pointer"

                                                        }}>
                                                        <i
                                                            className="d-inline-block fas fa-pencil-alt text-center mr-2"
                                                            onClick={() => this.activateCamera(label.imageLabel, index)}
                                                            key={index}> EDIT </i>
                                                    </div>

                                                    {/* <div
                                        style={{
                                        cursor: "pointer"
                                    }}>
                                        <i
                                            className="d-inline-block fas fa-eye float-right"
                                            onClick={() => this.togglePreview(label.imageSrc)}
                                            key={index}/>
                                    </div> */}
                                                </div>
                                            </CardFooter>
                                        )
                                        : (" ")}</div></Card>
                    }
                </div>
            ));



            images_row = <Row
                className="flex-row flex-nowrap images-div"
                style={{
                    height: "auto"
                }}>
                {/* <Col lg="2" md="3">
                            <div className="form-group">
                                <img id="img1" src={this.state.ndcImage} alt=""/>
                                <TooltipItem tooltipText="NDC Image" target="img1" placement="top"/>
                            </div>
                        </Col> */}
                {imageLabelsArr}
                <div className="card-block img-div">

                    <Card className="text-center">
                        <div className="ml-8" style={{ cursor: "pointer" }}
                            onClick={this.onAdditional}>
                            <i className="d-inline-block fas fa-plus fa-2x" />
                        </div>
                        <CardFooter className="icon-footer">
                            <span>Add Image</span>
                        </CardFooter>
                    </Card>
                </div>
            </Row>
        }

        return images_row;
    }

    activateCamera = (label, index) => {


        this.setState({ activeImage: label, cameraActive: true, setHotKeys: true, currentIndex: index, toggleImage: false, });

    };

    showImage(label) {
        this.setState({
            ...this.state,
            toggleImage: true,
            toShow_image: label
        })
    }

    onAdditional = () => {
        this.setState({
            imageCounter: this.state.imageCounter + 1
        });
        this.confirm();
    };

    confirm = () => {
        const imageLabels = this.state.imageLabels;
        const imgCounter = this.state.imageCounter;
        let image = {};
        image.imageType = this
            .state
            .imageLabel
            .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
                if (+ match === 0)
                    return ""; // or if (/\s+/.test(match)) for white spaces
                return index === 0
                    ? match.toLowerCase()
                    : match.toUpperCase();
            });
        //image.imageLabel = this.state.imageLabel;
        var re = /(\b[a-z](?!\b))/g;
        image.imageLabel = this
            .state
            .imageLabel
            .replace(re, function (x) {
                return x.toUpperCase();
            }) + "_" + imgCounter;
        image.imageSrc = ""
        imageLabels.push(image);
        this.setState({
            ...this.state.imageLabels,
            imageLabels: imageLabels
        });
        //this.toggleModal();
    };

    getUploadImageName = () => {
        const { fileToUpload, activeImage } = this.state;
        const prescriptionNumber = this.props.mqtt.prescriptionByNumber.rxInfo.prescriptionNumber;
        const patientId = this.props.mqtt.prescriptionByNumber.patientInfo?.patientId;
        let extension = 'jpg';

        if (fileToUpload?.type === 'application/pdf') {
            extension = 'pdf';
        } else if (fileToUpload?.type?.includes('image/')) {
            extension = fileToUpload.type.split('/')[1];
        }
        let label = 'image';
        if (activeImage === "Label Image") label = 'labelImage';
        else if (activeImage === "Prescription Image") label = 'prescriptionImage';
        else if (activeImage === "Pill Image") label = 'pillImage';
        else if (activeImage === "Rx Bottle Image") label = 'rxbottle';
        else label = activeImage?.replace(/\s+/g, '_') || 'misc';
        if (activeImage === "Prescription Image" && extension === 'jpg') {
            label = 'prescriptionImage';
        }
        const idPart = this.state.isFromModal ? patientId : prescriptionNumber;
        return `${idPart}_${label}.${extension}`;
    };

    getUploadImagePrefix = () => {
        let orgID;
        localStorage.orgID
            ? (orgID = localStorage.orgID)
            : (orgID = 1);
        let branch;
        localStorage.branch
            ? (branch = localStorage.branch)
            : (branch = "Chama");
        const branchName = branch,
            orgId = orgID;
        const patientId = this.props.mqtt.prescriptionByNumber.patientInfo?.patientId;
        const prescriptionNumber = this.props.mqtt.prescriptionByNumber.rxInfo.prescriptionNumber;
        let uploadImgPrefix = orgId + "/" + branchName + "/";
        uploadImgPrefix += this.state.isFromModal ? patientId : prescriptionNumber;
        return uploadImgPrefix;
    };

    topressKey() {
        this.setState({
            ...this.state,
            setHotKeys: false,
            canSubmit: false
        })
        this.handleStartClick();
    }


    handleStartClick() {
        const imageSrc = this.webcam?.getScreenshot();

        if (imageSrc !== null) {
            if (this.state.isFromModal) {
                const base64Data = imageSrc.split(',')[1];
                const contentType = 'image/jpeg';

                const byteCharacters = atob(base64Data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: contentType });

                const fileName = this.getUploadImageName();
                const filePrefix = this.getUploadImagePrefix();
                const imageBase = "https://tpms-prescription-images.s3.amazonaws.com/";
                const uploadedImgUrl = imageBase + filePrefix + "/" + fileName;

                axios.post("https://280sdpcj87.execute-api.us-east-1.amazonaws.com/dev/requestUploadURL", {
                    name: fileName,
                    type: contentType,
                    Prefix: filePrefix + "/"
                }).then(data => {
                    const uploadURL = data.data.uploadURL;
                    return axios.put(uploadURL, blob, {
                        headers: {
                            "Content-Type": contentType
                        },
                        transformRequest: [(data, headers) => {
                            delete headers.common.Authorization;
                            return data;
                        }]
                    }).then(() => {
                        if (this.modalCameraStream) {
                            this.modalCameraStream.getTracks().forEach((track) => track.stop());
                        }

                        this.setState({
                            modalCapturedImage: imageSrc,
                            modalCameraActive: false,
                            p_allergies: uploadedImgUrl, // S3 URL instead of Base64 
                            isFromModal: false,
                            uploadType: null,
                            uploadSource: 'image',
                        });
                    });
                });

                return;
            }

            // ORIGINAL CAMERA FLOW (might have used elsewhere)
            const imageBase = "https://tpms-prescription-images.s3.amazonaws.com/";
            const contentType = imageSrc.split(";")[0];
            const byteCharacters = atob(imageSrc.replace(/^data:image\/(jpeg);base64,/, ""));
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: contentType });

            const fileName = this.getUploadImageName();
            const filePrefix = this.getUploadImagePrefix();
            const uploadedImgUrl = imageBase + filePrefix + "/" + fileName;

            axios
                .post("https://280sdpcj87.execute-api.us-east-1.amazonaws.com/dev/requestUploadURL", {
                    name: fileName,
                    type: contentType,
                    Prefix: filePrefix + "/"
                })
                .then(data => {
                    const uploadImage = data.data;
                    return axios.put(uploadImage.uploadURL, blob, {
                        headers: {
                            "Content-Type": "data:image/jpeg"
                        },
                        transformRequest: [(data, headers) => {
                            delete headers.common.Authorization;
                            return data;
                        }]
                    }).then(() => {
                        const imageLabels = this.state.imageLabels.map(img => {
                            if (img.imageLabel === this.state.activeImage) {
                                img.imageSrc = imageSrc;
                                img.imageUrl = uploadedImgUrl;
                            }
                            return img;
                        });
                        this.setState({
                            imageLabels,
                            cameraActive: false,
                            enableSubmit: true,
                            canSubmit: true
                        });
                        this.onCapture();
                    });
                });
        } else {
            this.setState({ setHotKeys: true });
        }
    }

    doImageCaptures() {

        let imgCaps;
        let activeImage = this.state.activeImage
        let constraints = {
            video: {
                width: 850,
                height: 600
            }
        }
        let toPress;
        let setLabels;
        if (this.state.setHotKeys) {
            toPress = <Hotkeys keyName="c" onKeyUp={this.topressKey}>
                <i className="fas fa-camera" onClick={this.handleStartClick} /></Hotkeys>
        }
        else {
            toPress = <h6>Please Wait ....</h6>
        }
        if (this.state.cameraActive) {

            setLabels = <div >
                <div
                    className=""
                    style={{
                        position: "absolute",
                        textAlign: "center",
                        zIndex: "999",
                        color: "white",
                        width: "100%",
                        backgroundColor: "#000",
                        opacity: "0.3",
                        padding: "5px 0",
                        fontWeight: "bold",
                        borderRadius: "0.25rem"
                    }}>
                    Capture {activeImage}
                </div>
                <Webcam
                    audio={false}
                    videoConstraints={constraints}
                    screenshotFormat="image/jpeg"
                    ref={this.setRef}
                    height={600}
                    width={850} />
                <div
                    style={{
                        position: "absolute",
                        top: "92.5%",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "2rem",
                        color: "white",
                        cursor: "pointer",
                        backgroundColor: "#000",
                        opacity: "0.3",
                        padding: "5px 0",
                        fontWeight: "bold",
                        borderRadius: "0.25rem"
                    }}>
                    {/* <Hotkeys keyName="c" onKeyUp={this.topressKey}>
                                    <i className="fas fa-camera" onClick={this.handleStartClick}/></Hotkeys> */}
                    {toPress}
                </div>

            </div>
        }
        else {
            setLabels = <div></div>
        }


        // else{
        //     toPress=<div></div>
        // }

        imgCaps = <Container> <Card
            className="mx-auto mt-2"
            style={{
                height: "600px",
                width: "850px",
                border: "1px solid #000"
            }}>
            {setLabels}
        </Card></Container>

        return imgCaps;
    }
    activateCameraInModal = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            const video = document.getElementById('modal-camera-video');
            if (video) {
                video.srcObject = stream;
            }

            this.modalCameraStream = stream;
            this.setState({
                modalCameraActive: true,
                modalCapturedImage: null // Reset any previous capture
            });

        } catch (error) {
            console.error('Error accessing camera:', error);
            alert('Could not access the camera. Please check permissions.');
        }
    };
    resetUploadSelection = () => {
        if (this.fileInputRef?.current) {
            this.fileInputRef.current.value = '';
        }
        this.setState({
            uploadType: null,
            modalCapturedImage: null,
            p_allergies: '',
            modalCameraActive: false,
            uploadSource: '',
        });
    };
    // On checkbox selection, below method with find the Allergy information document(URL) from same patient's approved requests and re-use it in current the prescption.
    copyAllergyInfo = (event) => {
        const { patientId } = this.props;
        // const existingPatientAllergyInfo = this.props.mqtt.approvedPrescriptions.find(patient => patient?.patientInfo?.patientId === patientId);
        const existingPatientAllergyNotes = this.props.mqtt.prescriptionByNumber?.patientInfo?.patientAdditionalInfo?.notes?.split(' , ')[0]?.trim();;
        this.setState({
            ...this.state,
            p_allergies: event.target.checked ? existingPatientAllergyNotes : ""
        });
    }

    captureModalPhoto = () => {
        const video = document.getElementById('modal-camera-video');
        if (!video) return;

        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const base64Image = canvas.toDataURL('image/png'); // already includes `data:image/png;base64,...`

        if (this.modalCameraStream) {
            this.modalCameraStream.getTracks().forEach(track => track.stop());
        }

        this.setState({
            modalCapturedImage: base64Image,
            modalCameraActive: false,
            p_allergies: base64Image // this is the important line for uploading/saving
        });
    };



    getImageCaptures() {
        const { prescriptionByNumber, loading } = this.props.mqtt;
        let imgCaptures = <Spinner />
        let label = this.state.toShow_image;
        let toggleImage = this.state.toggleImage
        if (Object.keys(prescriptionByNumber).length > 0) {
            if (this.state.cameraActive && !toggleImage) {
                imgCaptures = this.doImageCaptures();
            }
            else if (!this.state.cameraActive && toggleImage) {
                imgCaptures = <Card
                    className="mx-auto mt-2"
                    style={{
                        height: "550px",
                        width: "850px",
                        border: "1px solid #000"
                    }}>
                    <div
                        className="font-style text-capitalize"
                        style={{
                            position: "absolute",
                            textAlign: "center",
                            zIndex: "999",
                            color: "white",
                            width: "100%",
                            backgroundColor: "#000",
                            opacity: "0.3",
                            padding: "5px 0",
                            fontWeight: "bold",
                            borderRadius: "0.25rem"
                        }}>
                        {label.imageType}
                    </div>
                    <img src={label.imageSrc}></img></Card>
            }

            else {
                imgCaptures = imgCaptures = <Card
                    className="mx-auto mt-2 text-center"
                    style={{
                        height: "550px",
                        width: "850px",
                        border: "1px solid #000",

                    }}>
                    <i className="fas fa-camera fa-5x" style={{ marginTop: "225px", color: "grey" }}></i>

                </Card>
            }

        }
        return imgCaptures;


    }

}

PrescriptionComponent.propTypes = {
    getPrescriptionHistory: PropTypes.func.isRequired,
    getPrescriptions: PropTypes.func.isRequired,
    postPrescriptions: PropTypes.func.isRequired,
    getPrescriptionByNumber: PropTypes.func.isRequired,
    mqtt: PropTypes.object.isRequired,
    presc_modal_view: PropTypes.func.isRequired,
    getDurInfo: PropTypes.func.isRequired

};

const mapStateToProps = state => ({ mqtt: state.mqtt, auth: state.auth });

export default connect(mapStateToProps, { getPrescriptions, getDurInfo, postPrescriptions, getPrescriptionHistory, presc_modal_view, getPrescriptionByNumber })(PrescriptionComponent);
